import React, { useMemo, useState } from 'react'
import { useCrmInfo } from '../../components/CrmLayout/CrmLayout.context'
import moment from 'moment/moment'
import useCrmSubscriptionsApi from '@api/useCrmSubscritions'
import { ITableState } from '@utils/sort'
import { initialPagination } from '../../../MainPage/MainPage'
import styles from './SubscriptionsPage.module.scss'
import RangePickerUi from '@components/ui/RangePickerUi/RangePickerUi'
import CustomTable from '@components/ui/CustomTable/CustomTable'
import { Spin } from 'antd'
import { crmSubscriptionColumns } from './subscriptions.column'
import { subscriptionMapper, subscriptionStatusMapper } from '@utils/mappers'
import { fullDateFormat } from '@utils/time'
import WithLabel from '@components/ui/WithLabel/WithLabel'
import { antIcon } from '@components/TopUsers/TopUsers'
import Box from '@components/ui/Box/Box'
import { IconCalendar } from '@utils/icons'

const SubscriptionPage: React.FC = () => {
  const [crmInfo] = useCrmInfo()
  const [state, setState] = useState<ITableState>(initialPagination)
  const [selectedDate, setSelectedDate] = useState<[moment.Moment | null, moment.Moment | null]>([
    moment().startOf('year'),
    moment().endOf('year'),
  ])

  const { result } = useCrmSubscriptionsApi({
    crmId: crmInfo?.id,
    dates: selectedDate,
    pagination: state,
  })

  const mapped = useMemo(() => {
    return (
      result?.rows.map((el) => {
        return {
          ...el,
          plan: subscriptionMapper(el.plan.type),
          price: el.plan.price + ' USDT',
          status: subscriptionStatusMapper(el.status),
          startDate: fullDateFormat(el.startDate),
          endDate: fullDateFormat(el.endDate),
          updatedAt: fullDateFormat(el.updatedAt),
        }
      }) ?? []
    )
  }, [result])

  return (
    <Box className={styles.container}>
      <div className={styles.header}>
        <WithLabel
          label='Выберите период времени:'
          icon={<IconCalendar width='18' height='18' fill='var(--color-main)' />}
        >
          <RangePickerUi value={selectedDate} onChange={setSelectedDate} allowClear={false} />
        </WithLabel>
      </div>
      <div className={styles.table}>
        {mapped ? (
          <CustomTable
            columns={crmSubscriptionColumns}
            dataSource={mapped}
            allCount={result?.count ?? 0}
            updatePagination={setState}
            pagination={state.pagination}
          />
        ) : (
          <div className={styles.loadWrapp}>
            <Spin indicator={antIcon} className={styles.loadSpin} />
          </div>
        )}
      </div>
    </Box>
  )
}

export default SubscriptionPage
